module.exports = "<div id=\"overlay\" ><div style=\"margin-top:300px;z-index:10001;text-align: center;font-size: 20px;\">Logout please wait...</div></div>\r\n"